import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const partners = [
  { name: 'Ministry of Health', logo: '/mintryofhealthlogo.png' },
  { name: 'Mulago Hospital', logo: '/Mulago-Hospital.jpg' },
  { name: 'Makerere University', logo: '/makerere_university.jpg' },
  { name: 'Kampala Pharmaceutical', logo: '/kampalapharmacuticallogo.png' },
  { name: 'Joint Medical Stores', logo: '/JMS_logo-1.png' },
  { name: 'World Food Program', logo: '/worldfoodprogram.png' },
  { name: 'Lubaga Hospital', logo: '/lubagahospital.png' },
  { name: 'Mengo Hospital', logo: '/mengohospitallogo.png' },
  { name: 'East African Medical Vitals', logo: '/eamv.jpeg' }
];

const PartnersSlider = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => {
      if (sliderRef.current) {
        observer.unobserve(sliderRef.current);
      }
    };
  }, []);

  // Duplicate the partners array to create a seamless loop
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="py-10 sm:py-14 md:py-16 xl:py-20 bg-gray-50 w-full overflow-x-hidden" ref={sliderRef}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-8 xl:px-12">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Our Trusted Partners</h2>
          <p className="mt-2 text-sm sm:text-base text-gray-600 max-w-2xl mx-auto">
            We're proud to partner with leading organizations across Uganda
          </p>
        </div>
        
        <div className="relative overflow-x-auto overflow-y-visible py-4 w-full [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div 
            className={`flex items-center space-x-4 sm:space-x-8 md:space-x-16 ${isVisible ? 'animate-scroll' : ''}`}
            style={{
              display: 'flex',
              width: 'max-content',
              animation: isVisible ? 'scroll 30s linear infinite' : 'none',
            }}
          >
            {duplicatedPartners.map((partner, index) => (
              <Link 
                to="/clientele" 
                key={`${partner.name}-${index}`} 
                className="flex-shrink-0 flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity duration-300"
                style={{ minWidth: '160px' }}
                onClick={(e) => {
                  // Smooth scroll to the top of the clientele page
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name} 
                  className="h-12 sm:h-16 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
                  loading="lazy"
                />
              </Link>
            ))}
          </div>
          
          {/* Gradient overlays for smooth edges */}
          <div className="absolute top-0 left-0 w-24 h-full bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
          <div className="absolute top-0 right-0 w-24 h-full bg-gradient-to-l from-gray-50 to-transparent z-10"></div>
          
          {/* CSS Animation */}
          <style dangerouslySetInnerHTML={{
            __html: `
              @keyframes scroll {
                0% {
                  transform: translateX(0);
                }
                100% {
                  transform: translateX(calc(-160px * ${partners.length}));
                }
              }
            `
          }} />
        </div>
      </div>
    </section>
  );
};

export default PartnersSlider;
